module.exports = __webpack_public_path__ + "img/logo.cc578fc5.png";